import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AdminService } from 'src/app/services/admin.service';

@Component({
    selector: 'vex-toolbar-user',
    templateUrl: './toolbar-user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatRippleModule, MatIconModule]
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen: boolean = false;
  displayName = this.getDisplayName();
  profileImage = 'assets/images/useravatar.png';

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private admin: AdminService
  ) {}

  ngOnInit() {
    this.admin.getUserProfile().subscribe({
      next: (profile: any) => {
        const name = String(profile?.fullname || profile?.username || '').trim();
        const image = String(profile?.profileimage || '').trim();

        if (name) {
          this.displayName = name;
        }

        this.profileImage = image || 'assets/images/useravatar.png';
        this.cd.markForCheck();
      }
    });
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }

  private getDisplayName(): string {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) return 'User';

    try {
      const payload: any = JSON.parse(atob(token.split('.')[1]));
      const value =
        payload?.fullname ||
        payload?.fullName ||
        payload?.FullName ||
        payload?.name ||
        payload?.Name ||
        payload?.given_name ||
        payload?.email ||
        payload?.username ||
        payload?.UserName ||
        payload?.unique_name;

      const name = String(value || '').trim();
      return name && !/^\d+$/.test(name) ? name : 'User';
    } catch {
      return 'User';
    }
  }
}
